import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Box, IconButton, Typography, CircularProgress } from "@mui/material";

import { useUserTrophies } from "../../api/queries/useUserTrophies";

import { EntityBackToProfileIcon } from "../../assets/icons/entity-icons";
import EmptyTrophiesFigure from "../../assets/images/empty-trophies-figure.png";

import { styles } from "../../components/Trophies/styles";
import { TrophyCard } from "../../components/Trophies/TrophyCard";

const TROPHIES_LIMIT = 20;

const PlayerFullTrophies = () => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "trophies",
  });
  const navigate = useNavigate();
  const { userId } = useParams();

  const {
    data: trophiesData,
    isLoading: isTrophiesLoading,
    isError: isTrophiesError,
  } = useUserTrophies(userId!, TROPHIES_LIMIT, 0);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box sx={pageStyles.container}>
      <Typography sx={pageStyles.title}>
        <IconButton size="small" onClick={handleBack}>
          <EntityBackToProfileIcon />
        </IconButton>
        {t("trophies")}
      </Typography>
      <Box sx={pageStyles.contentWrapper}>
        {isTrophiesLoading && (
          <Box sx={pageStyles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}

        {!isTrophiesLoading && (isTrophiesError || !trophiesData?.length) && <NoTrophies />}

        {!isTrophiesLoading && trophiesData && trophiesData.length > 0 && (
          <Box sx={{ ...styles.trophyGrid, flexWrap: "wrap" }}>
            {trophiesData.map((trophy) => (
              <TrophyCard key={trophy.id} trophy={trophy} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PlayerFullTrophies;

const NoTrophies = () => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "trophies",
  });

  return (
    <Box sx={pageStyles.noTrophiesContainer}>
      <Box component="img" sx={pageStyles.noTrophiesImage} src={EmptyTrophiesFigure} alt="empty-trophies" />
      <Typography sx={pageStyles.noTrophiesText}>{t("noTrophies")}</Typography>
    </Box>
  );
};

const pageStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "16px",
  },
  contentWrapper: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    borderRadius: "8px",
    minHeight: "70vh",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    py: 4,
  },
  noTrophiesContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    py: 4,
  },
  noTrophiesImage: {
    width: "73.51px",
    height: "73.485px",
  },
  noTrophiesText: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    textAlign: "center",
  },
};
